module.exports = __webpack_public_path__ + "static/media/btn-doc.8894c74c.svg";